<app-custom-modal>
    <div modal-title>
        <h4 class="modal-title">{{ "new_features.title" | translate }}</h4>
    </div>
    <div modal-body>
        <p>{{ "new_features.sub_title" | translate }}</p>
        <p>{{ "new_features.whats_changed" | translate }}</p>
        <ul>
            @for (item of [].constructor(5); track $index) {
                <li>
                    <strong>{{ "new_features.item_" + ($index + 1) + "_title" | translate }}: </strong>
                    <span [innerHTML]="'new_features.item_' + ($index + 1) + '_desc' | translate"></span>
                </li>
            }
        </ul>
    </div>
    <div modal-footer>
        <app-aw-button size="large" (clickEmitter)="modalService.dismissAll()">
            <span button-content>OK</span>
        </app-aw-button>
    </div>
</app-custom-modal>
